import { clearCanvas, drawGrid, normalizeRange, setupCanvas } from './canvas-utils';

export type WaterfallStep = {
    label: string;
    value: number;
};

export function renderWaterfallChart(canvas: HTMLCanvasElement, steps: WaterfallStep[]): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    drawGrid(ctx, width, height, 4, 4, 'rgba(255,255,255,0.08)');
    if (steps.length === 0) return;

    const cumulative: number[] = [0];
    steps.forEach((step) => {
        cumulative.push(cumulative[cumulative.length - 1] + step.value);
    });

    const { min, max } = normalizeRange(cumulative);
    const yOf = (v: number) => height - ((v - min) / (max - min)) * height;
    const barW = Math.max(8, Math.floor(width / Math.max(1, steps.length * 1.6)));

    let running = 0;
    steps.forEach((step, idx) => {
        const next = running + step.value;
        const x = Math.floor(((idx + 0.5) / steps.length) * width);
        const y0 = yOf(running);
        const y1 = yOf(next);
        const top = Math.min(y0, y1);
        const barH = Math.max(1, Math.abs(y1 - y0));

        ctx.fillStyle = step.value >= 0 ? '#15b57a' : '#d94736';
        ctx.fillRect(x - Math.floor(barW / 2), top, barW, barH);

        if (idx < steps.length - 1) {
            const nextX = Math.floor((((idx + 1) + 0.5) / steps.length) * width);
            ctx.strokeStyle = 'rgba(255,255,255,0.28)';
            ctx.setLineDash([3, 3]);
            ctx.beginPath();
            ctx.moveTo(x + Math.floor(barW / 2), y1);
            ctx.lineTo(nextX - Math.floor(barW / 2), y1);
            ctx.stroke();
            ctx.setLineDash([]);
        }

        running = next;
    });
}
